import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home/Home.vue";
import CrearOs from "../views/crearOS/CrearOs";
import Manual from "../views/crearOS/Manual";
import NotaVenta from "../views/crearOS/NotaVenta";
import Proveedores from "../views/Proveedores/Proveedores";
import VisitaTecnica from "../views/VisitaTecnica/VisitaTecnica";
import DetailsOS from "../views/Home/DetailsOS";
import Tracking from "../views/Home/Tracking";
import TrackingProyecto from "../views/Proyectos/TrackingProyecto";
import AdminOS from "../views/adminOS/AdminOS";
import PrintDetailOs from "../views/adminOS/PrintDetailOs";
import Tecnicos from "../views/Tecnicos/Tecnicos";
import CreateProvider from "../views/Proveedores/CreateProvider";
import EditProvider from "../views/Proveedores/EditProvider";
import Services from '../views/Servicios/Services'
import PageNotFound from '../views/PageNotFound'
import BlockedPage from '../views/BlockedPage'
import ReportesServicios from '../views/Reportes/ReportesServicios'
import ReportesVtex from '../views/Reportes/ReportesVtex'
import ReportesProyectos from '../views/Reportes/ReportesProyectos'
import CargaMasiva from '@/views/CargaMasiva/CargaMasiva' 
import ProgramacionMasiva from '@/views/CargaMasiva/ProgramacionMasiva' 
import Clientes  from '@/views/Clientes/Clientes' 
import OneTrack from '@/views/OneTrack/OneTrack'
import DescargaReporte from '@/views/Reportes/DescargaReporte'
import store from "@/store";
import Mantenedor from '@/views/MantenedorFechas/Mantenedor'
import Proyectos from '@/views/Proyectos/Proyectos'
import DetalleProyecto from '@/views/Proyectos/DetalleProyecto'
//import authentication from '../auth/authentication'
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: {
        name: "Login",
      },
      meta: { disallowAuthed: true }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { disallowAuthed: true }
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    {
      path: "/crear-os",
      name: "CreacionOs",
      component: CrearOs,
      meta: {
        requiresAuthentication: true,
      }
    },
    {
      path: "/crear-os/nota-venta",
      name: "NotaVenta",
      component: NotaVenta,
      meta: {
        requiresAuthentication: true,
      }
    },
    {
      path: "/crear-os/manual",
      name: "Manual",
      component: Manual,
      meta: {
        requiresAuthentication: true,
      }
    },
    {
      path: "/tecnico",
      name: "Tecnicos",
      component: Tecnicos,
      meta: {
        requiresAuthentication: true,
      },
    },
    {
      path: "/proveedores",
      name: "Proveedores",
      component: Proveedores,
      props: true,
      meta: {
        requiresAuthentication: true,
      }
    },
    {
      path: "/crear-proveedor",
      name: "CreateProvider",
      component: CreateProvider,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    
    {
      path: "/crear-os/manual/:id/tipo/:tipo",
      name: "ManualOs",
      component: Manual,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    {
      path: "/crear-os/nota-venta/:id/tipo/:tipo",
      name: "NotaVentaTipo",
      component: NotaVenta,
      meta: {
        requiresAuthentication: true,
      }
    },
    {
      path: "/visita-tecnica",
      name: "VisitaTecnica",
      component: VisitaTecnica,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
   
    {
      path: "/admin-os",
      name: "AdministracionOs",
      component: AdminOS,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },

    {
      path: "/tracking/:id",
      component: Tracking,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    {
      path: "/tracking-proyecto/:id",
      component: TrackingProyecto,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    
    {
      path: "/details-os/:id",
      component: DetailsOS,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    {
      path: "/detalle-proyecto/:os/informe/:informe/id/:id",
      component: DetalleProyecto,
      name: 'DetalleProyecto',
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    {
      path: "/mantenedor-fechas",
      name:"MantenedorFechas",
      component: Mantenedor,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    {
      path: "/print-os/:id",
      component: PrintDetailOs,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    {
      path: "/editar-proveedor/:id",
      component: EditProvider,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    {
      path: "/servicios",
      name: "Servicios",
      component: Services,
      props: true,
      meta: {
        requiresAuthentication: true,
      },
    },
    {
      path: "/reportes-os",
      name: "ReportesServicios",
      component: ReportesServicios,
      meta: {
        requiresAuthentication: true,
      }
    },
    {
      path: "/reportes-vtex",
      name: "ReportesVtex",
      component: ReportesVtex,
      meta: {
        requiresAuthentication: true,
      }
    },
    {
      path: "/reportes-proyectos",
      name: "ReportesProyectos",
      component: ReportesProyectos,
      meta: {
        requiresAuthentication: true,
      }
    },
    {
      path: "/descarga-reporte",
      name: "DescargaReporte",
      component: DescargaReporte,
      meta: {
        requiresAuthentication: true,
      }
    },
    {
      path:"/carga-masiva",
      name:"CargaMasiva",
      component:CargaMasiva,
      meta:{
        requiresAuthentication:true
      }
    },
    {
      path:"/programacion-masiva",
      name:"ProgramacionMasiva",
      component:ProgramacionMasiva,
      meta:{
        requiresAuthentication:true
      }
    },
    {
      path:"/mantenimiento/cliente",
      name:"Clientes",
      component:Clientes,
      meta:{
        requiresAuthentication:true
      }
    }, 
    {
      path:"/one-track",
      name:"OneTrack",
      component:OneTrack,
      meta:{
        requiresAuthentication:true
      }
    },
    {
      path:"/mantenedor-fechas",
      name:"Mantenedor",
      component:Mantenedor,
      meta:{
        requiresAuthentication:true
      }
    },
    {
      path:"/gestion-proyectos",
      name:"Proyectos",
      component:Proyectos,
      meta:{
        requiresAuthentication:true
      }
    },
    {
      path: "/404",
      name: "BlockedPage",
      component: BlockedPage,
      meta: {
        requiresAuthentication: true,
      }
    },
    {
      path: "*",
      component: PageNotFound,
      meta: {
        requiresAuthentication: true,
      },
    }
  ],
});
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["module/isAuthenticated"];
  /*if (to.name == 'DescargaReporte') {
    console.log('iam in')
    next({ name: "DescargaReporte" });
  }
  else */
  if (to.matched.some(record => record.meta.requiresAuthentication)) {

    if (isAuthenticated) {

      next()
    }
    else {
      next({ name: "Login" });
    }
  }
  else {
    if (isAuthenticated && to.meta.disallowAuthed) {

      next({ name: "AdministracionOs" });
    }
    next()
  }

});

export default router;
